import React, { useContext, useEffect, useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { TagsInput } from 'react-tag-input-component';
import { GlobalContext } from '../../App';
import axios from 'axios';
import { getHeaders, headers } from '../../http/axios';
import { toast } from 'react-toastify';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { joditConfig } from '../../config/joditConfig';
import JoditEditor from 'jodit-react';

export default function EditBlog() {
    const { id } = useParams();
    const imageUrl = "./assets/images/";
    const navigate = useNavigate();
    const { setSpinner } = useContext(GlobalContext);
    const [categoryData, setCategoryData] = useState([]);
    const [blogDetails, setBlogDetails] = useState();
    const [selectedTag, setSelectedTag] = useState([]);
    const {
        control,
        register,
        handleSubmit,
        watch,
        setValue,
        trigger,
        formState: { errors },
    } = useForm({
        mode: "onChange",
    });
    const handleBackClick = () => {
        navigate(-1);
    };
    const [previewImage, setPreviewImage] = useState(null);
    const [previewThumbnailImage, setPreviewThumbnailImage] = useState(null);

    const handleRemoveTag = (indexToRemove) => {
        setSelectedTag(selectedTag.filter((_, index) => index !== indexToRemove));
    };
    const getBannerImage = watch("bannerImage")?.[0];
    const getThumbnailImage = watch("thumbnailImage")?.[0];

    const userInfo = JSON.parse(localStorage.getItem("Saras_Blog_Admin"));
    const authorId = userInfo?.id || null; 
    
    const handleFileUpload = (event, setImage) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onloadend = () => {
            setImage(reader.result);
        };

        if (file) {
            reader.readAsDataURL(file);
        }
    };

    const editor = useRef(null);
    
    useEffect(() => {
        setSpinner(true);
        axios
            .get(`${process.env.REACT_APP_API_KEY}blog/${id}`, {
                headers: getHeaders(),
            })
            .then((response) => {
                const data = response?.data?.data;
                const tagsArray = data?.tags ? data.tags.split(',').map(tag => tag.trim()) : [];
                setBlogDetails(data);
                setValue("blog_title", data?.blog_title);
                setValue("content", data?.content ? data?.content : "");
                setSelectedTag(tagsArray); // Set tags correctly
                setValue("banner_image", data?.banner_image ? data.banner_image[0]?.name : "");
                setValue("thumbnail_image", data?.thumbnail_image ? data.thumbnail_image[0]?.name : "");
                setValue("category", data.category.id);
                setValue("author_id", authorId);
                setValue("blog_url",data?.blog_url);
                setValue("meta_title", data?.meta_title);
                setValue("meta_description", data?.meta_description);
                setValue("meta_keywords", data?.meta_keywords);


            })
            .catch((error) => {
                toast.error(error?.response?.data?.message);
            })
            .finally(() => {
                setSpinner(false);
            });
    }, [id]);
    useEffect(() => {
        if (getBannerImage) {
            handleFileUpload(
                { target: { files: [getBannerImage] } },
                setPreviewImage
            );
        }
        if (getThumbnailImage) {
            handleFileUpload(
                { target: { files: [getThumbnailImage] } },
                setPreviewThumbnailImage
            );
        }
    }, [getBannerImage, getThumbnailImage]);

    // category data 
    const getCategory = () => {
        setSpinner(true);
        axios.get(
            `${process.env.REACT_APP_API_KEY}blog/categories`,
            { headers: getHeaders() }
        )
            .then((res) => {
                console.log(res.data);
                if (Array.isArray(res.data.data)) {
                    setCategoryData(res.data.data);
                } else {
                    console.error('Expected an array but got:', res.data);
                }
            })
            .finally(() => {
                setSpinner(false);
            });
    };

    useEffect(() => {
        getCategory();
    }, []);


    // edit Blog function
    const editBlog = async (data) => {
        const imageKey = { bannerKey: "", thumbnailKey: "" };
        setSpinner(true);
        try {
           
            const finalResponse = await axios.put(
                `${process.env.REACT_APP_API_KEY}blog/${id}`,

                {
                    blog_title: data.blog_title,
                    content: data.content ? data.content : "",
                    banner_image: imageKey.bannerKey
                        ? imageKey.bannerKey
                        : blogDetails.banner_image,
                    thumbnail_image: imageKey.thumbnailKey
                        ? imageKey.thumbnailKey
                        : blogDetails.thumbnail_image,
                    blog_category_id: data.category,
                    tags: selectedTag.join(', '),
                    author_id: authorId,
                    blog_url: data.blog_url,
                    meta_title: data.meta_title,
                    meta_description: data.meta_description,
                    meta_keywords: data.meta_keywords,


                },
                {
                    headers: getHeaders(),
                }

            );
            if (previewImage) {
                const formData = new FormData();
                formData.append("file", data.bannerImage[0]);
                formData.append("type", "banner_image");


                const bannerResponse = await axios.post(
                    `${process.env.REACT_APP_API_KEY}blog/upload-image/${finalResponse.data?.data?.id}`,
                    formData,
                    {
                        headers: {
                            ...getHeaders(),
                            'Content-Type': 'multipart/form-data', // Set content type for file upload
                        },
                    }
                );

                imageKey.bannerKey = bannerResponse.data.url;
                console.log(bannerResponse, "bannerResponse");

            }
            if (previewThumbnailImage) {
                const formDataForThumbnail = new FormData();
                formDataForThumbnail.append("file", data.thumbnailImage[0]);
                formDataForThumbnail.append("type", "thumbnail_image");

                const thumbnailResponse = await axios.post(
                    `${process.env.REACT_APP_API_KEY}blog/upload-image/${finalResponse.data?.data?.id}`,
                    formDataForThumbnail,
                    {
                        headers: {
                            ...getHeaders(),
                            'Content-Type': 'multipart/form-data', // Set content type for file upload
                        },
                    }
                );

                imageKey.thumbnailKey = thumbnailResponse.data.url;
            }
            console.log("Final response", finalResponse.data);
            toast.success(finalResponse.data.message);
            navigate("/blog")
        } catch (error) {
            console.error("Error occurred while uploading images:", error);
            toast.error(error.response.data.message);
        } finally {
            setSpinner(false);
        }
    };

    const handleFileReset = (file) => {
        if (file === "previewImage") {
            setPreviewImage("");
            setValue("bannerImage", "");
            setBlogDetails({ ...blogDetails, banner_image: "" });
        } else {
            setPreviewThumbnailImage("");
            setValue("thumbnailImage", "");
            setBlogDetails({ ...blogDetails, thumbnail_image: "" });
        }
    };
    return (
        <div className="admin-form">
            <div className="title flex justify-start items-center mb-8 gap-4">
                <div className="bg-white py-3 px-4 rounded-[6px] shadow pointer" onClick={handleBackClick}>
                    <img src={imageUrl + "back.svg"} alt="" />
                </div>
                <h2>Edit Blog</h2>
            </div>

            <div className="data-box overflow-auto">
                <div className="p-8 ">
                    <form onSubmit={handleSubmit(editBlog)}>
                        <div class="grid grid-cols-12 gap-x-6 gap-y-10  ">
                            <div class="col-span-full">
                                <label for="blog_title" class="block text-sm font-medium leading-6 text-gray-900">Title</label>
                                <div class="mt-3 input-box">
                                    <input type="text"  {...register("blog_title")} name="blog_title" id="blog_title" autocomplete="blog_title" placeholder='Enter categor name'
                                        maxLength={255}
                                        class="block w-full placeholder:text-gray-400 sm:text-sm sm:leading-6" />
                                    {errors.blog_title && <span className='text-[red] text-[13px]'>This field is required</span>}
                                </div>
                            </div>
                            <div class="col-span-full mb-5 pb-5">
                                <label for="content" class="block text-sm font-medium leading-6 text-gray-900">Content</label>
                                <div class="mt-3  h-[250px]">
                                    <Controller
                                        control={control}
                                        name="content" rules={{
                                            required: "Content is required",
                                            validate: (value) => value.trim().length > 0 || "Content is required",
                                        }}
                                        render={({ field }) => (
                                            // <CKEditor
                                            //     editor={ClassicEditor}
                                            //     data={field.value || ''}
                                            //     onChange={(event, editor) => {
                                            //         const data = editor.getData();
                                            //         if (data) {
                                            //             field.onChange(data);
                                            //         }
                                            //     }}
                                            // />

                                            // <JoditEditor
                                            // ref={editor}
                                            // value={field.value}
                                            // config={joditConfig}
                                            // onChange={newContent => {
                                            //     if (newContent) {
                                            //         field.onChange(newContent);
                                            //     }
                                            // }}
                                            // />
                                            <JoditEditor
                                            ref={editor}
                                            value={field.value}
                                            config={joditConfig}
                                            onBlur={newContent => {
                                              // Triggers when user clicks away — catches paste & input
                                              if (newContent !== field.value) {
                                                field.onChange(newContent);
                                              }
                                            }}
                                            onChange={() => {
                                              // Still keep this for regular typing
                                            }}
                                            onReady={instance => {
                                                instance.events.on("afterPaste", () => {
                                                  const updated = instance.value;
                                                  if (updated !== field.value) {
                                                    field.onChange(updated);
                                                  }
                                                });
                                              
                                                instance.events.on("change", () => {
                                                  const updated = instance.value;
                                                  if (updated !== field.value) {
                                                    field.onChange(updated);
                                                  }
                                                });
                                              }}
                                          />
                                        )}
                                    />
                                    {errors.content && <span className='text-[red] text-[13px] block absolute top-[43.5rem]'>Content is required</span>}
                                </div>
                            </div>

                            <div className="col-span-6">
                                <label  for="category" className="block text-sm font-medium leading-6 text-gray-900">Category</label>
                                <div className="mt-3 input-box">
                                    <select {...register("category", { required: true }) } name="category">
                                        <option >-- Select category --</option>
                                        <hr></hr>

                                        {categoryData?.map((item, index) => (
                                            <option key={item.id} value={item.id}>{item.name}</option>
                                        ))}
                                    </select>
                                    {errors.category && <span>This field is required</span>}
                                </div>
                                {errors.category && <span className='text-[red] text-[13px]'>This field is required</span>}

                            </div>
                            <div class="col-span-6">
                                <label for="about" class="block text-sm font-medium leading-6 text-gray-900">Tags</label>
                                <div class="mt-3">
                                    <TagsInput
                                        disableBackspaceRemove={true}
                                        value={selectedTag}
                                        onChange={(e) => {
                                            setSelectedTag(e);
                                        }}
                                        name="tags"
                                        placeHolder="Enter Tags"
                                    />
                                    <div className="flex flex-wrap gap-x-5 gap-y-4 mt-5 items-center">
                                        {selectedTag?.map((item, index) => (
                                            <div key={index} className="tag-item border border-[#E57549] rounded-[3px] px-3 py-1 primary-txt flex gap-2 mt-0 items-center">
                                                <span>{item}</span>
                                                <button
                                                    className="remove-button "
                                                    onClick={() => handleRemoveTag(index)}
                                                >
                                                    <img src={imageUrl + "cross.svg"} alt="" width={"16px"} />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                          

                            <div class="col-span-6">
                                <label for="blog_url" class="block text-sm font-medium leading-6 text-gray-900">Blog Url</label>
                                <div class="mt-3 input-box">
                                    <input type="text"  {...register("blog_url")} name="blog_url" id="blog_url" autocomplete="blog_url" placeholder='Enter Blog Url'
                                        maxLength={255}
                                        class="block w-full placeholder:text-gray-400 sm:text-sm sm:leading-6" />
                                    {errors.blog_url && <span className='text-[red] text-[13px]'>This field is required</span>}
                                </div>
                            </div>

                             {/* /Blog Meta Tags/ */}
                        
                             <div class="col-span-6">
                                <label for="meta_title" class="block text-sm font-medium leading-6 text-gray-900">Meta Title</label>
                                <div class="mt-3 input-box">
                                    <input type="text"  {...register("meta_title")} name="meta_title" id="meta_title" autocomplete="meta_title" placeholder='Enter Meta Title'
                                        maxLength={255}
                                        class="block w-full placeholder:text-gray-400 sm:text-sm sm:leading-6" />
                                    {errors.blog_url && <span className='text-[red] text-[13px]'>This field is required</span>}
                                </div>
                            </div>

                            <div class="col-span-6">
                                <label for="meta_description" class="block text-sm font-medium leading-6 text-gray-900">Meta Description</label>
                                <div class="mt-3 input-box">
                                    <input type="text"  {...register("meta_description")} name="meta_description" id="meta_description" autocomplete="meta_description" placeholder='Enter Meta Description'
                                        maxLength={255}
                                        class="block w-full placeholder:text-gray-400 sm:text-sm sm:leading-6" />
                                    {errors.blog_url && <span className='text-[red] text-[13px]'>This field is required</span>}
                                </div>
                            </div>

                            <div class="col-span-6">
                                <label for="meta_keywords" class="block text-sm font-medium leading-6 text-gray-900">Meta Keywords</label>
                                <div class="mt-3 input-box">
                                    <input type="text"  {...register("meta_keywords")} name="meta_keywords" id="meta_keywords" autocomplete="meta_keywords" placeholder='Enter Meta Keywords'
                                        maxLength={255}
                                        class="block w-full placeholder:text-gray-400 sm:text-sm sm:leading-6" />
                                    {errors.blog_url && <span className='text-[red] text-[13px]'>This field is required</span>}
                                </div>
                            </div>
                            {/* blog image  */}
                            <div className="col-span-full grid grid-cols-12 gap-x-6 gap-y-10">
                                <div className="form-group col-span-6">
                                    <label htmlFor="banner-image ">
                                        Banner Image
                                    </label>
                                    <div className="set-cross-icon mt-3  relative">
                                        <label htmlFor="upload" className="upload_file">
                                            <input
                                                id="upload"
                                                type="file"
                                                className="hidden"
                                                {...register("bannerImage", { required: false })}
                                            />
                                            <div className="placeholder-img">
                                                <div className="placeholder-img">
                                                    {previewImage || blogDetails?.banner_image ? (
                                                        <>
                                                            <img
                                                                src={
                                                                    previewImage
                                                                        ? previewImage
                                                                        : `
                                                                    ${blogDetails?.banner_image}`
                                                                }
                                                                alt="banner"
                                                            />
                                                        </>
                                                    ) : (
                                                        <img src={imageUrl + "upload-banner.svg"} alt="banner" />
                                                    )} </div>
                                            </div>
                                        </label>
                                        {(previewImage || blogDetails?.banner_image) && (
                                            <span className="cross pointer absolute top-[-8px]  right-[-8px]"
                                                onClick={() => {
                                                    handleFileReset("previewImage");
                                                }}
                                            >
                                                <img src={imageUrl + "cross.svg"} alt="" />
                                            </span>
                                        )}
                                        {errors.bannerImage && (
                                            <span style={{ color: "red" }}>Banner Image is required</span>
                                        )}
                                    </div>
                                </div>
                                <div className="form-group col-span-6">
                                    <label htmlFor="thumbnail-image">
                                        Thumbnail Image
                                    </label>
                                    <div className="set-cross-icon mt-3  relative">
                                        <label htmlFor="upload1" className="upload_file">
                                            <input
                                                id="upload1"
                                                type="file"
                                                className="hidden"
                                                {...register("thumbnailImage", { required: false })}
                                            />
                                            <div className="placeholder-img">
                                                {previewThumbnailImage || blogDetails?.thumbnail_image ? (
                                                    <>
                                                        <img
                                                            src={
                                                                previewThumbnailImage
                                                                    ? previewThumbnailImage
                                                                    : `
                                                                    ${blogDetails?.thumbnail_image}`
                                                            }
                                                            alt="banner"
                                                        />
                                                    </>
                                                ) : (
                                                    <img src={imageUrl + "upload-banner.svg"} alt="banner" />
                                                )} </div>
                                        </label>
                                        {(previewThumbnailImage || blogDetails?.thumbnail_image) && (
                                            <span className="cross cross pointer absolute top-[-8px]  right-[-8px]"
                                                onClick={() => {
                                                    handleFileReset("thumbnailImage");
                                                }}
                                            >
                                                <img src={imageUrl + "cross.svg"} alt="" />
                                            </span>
                                        )}
                                        {errors.thumbnail_image && (
                                            <span style={{ color: "red" }}>
                                                Thumbnail Image is required
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="flex items-center justify-between">
                            <button type="submit" class="btn mt-8 w-2/12 text-center text-base">
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div >
    )
}
